/**
 * data-export-failure-response.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { validateAs, validateFor, validateOpaqueID, validateTSEnum }
  from "../../validation/decorators";
import { IncomingMessage } from "../general/incoming-message";
import { ResponseCode } from "../general/response-code";
import { MessageTag } from "../message-tag";

@validateFor(MessageTag.RSP_DATA_EXPORT_FAILURE)
export class DataExportFailureResponse extends IncomingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.RSP_DATA_EXPORT_FAILURE;

  @validateOpaqueID()
  public exportId : number;

  @validateTSEnum(ResponseCode)
  public code : ResponseCode;

  @validateAs("string")
  public reason : string;
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/export/data-export-failure-response.ts